export const SET_TITLE = 'SET_TITLE';
export const SET_LOGIN_DETAILS = 'SET_LOGIN_DETAILS';
export const REFRESH_LOGIN_SESSION = 'REFRESH_LOGIN_SESSION';
export const UPDATE_LAST_API_SESSION = 'UPDATE_LAST_API_SESSION';
export const SESSION_EXPIRED_302 = 'SESSION_EXPIRED_302';
export const SESSION_EXPIRED_302_RESET = 'SESSION_EXPIRED_302_RESET';
export const SET_BP_USER_AUTH_DETAILS = 'SET_BP_USER_AUTH_DETAILS';
export const SET_NOTIFICATIONS_CLIENTID = 'SET_NOTIFICATIONS_CLIENTID';
export const PASSWORDLESS_STATUS = 'PASSWORDLESS_STATUS';
